import { BathIcon } from "@assets";
import { Flex, Text } from "@chakra-ui/react";
import { NFTEvent, NFTEventInfo } from "@models/event";
import { DEFAULT_LANGUAGE } from "@models/language";
import Image from "next/image";

const AID = process.env.NEXT_PUBLIC_STAY22_AID || "moongate";

const _t = (key?: string, language = DEFAULT_LANGUAGE) => key || "";

const milisecondsToSeconds = (miliseconds: number) => {
  return ~~(miliseconds / 1000);
};

const Stay22HotelBooking = ({
  info,
  event,
}: {
  info: NFTEventInfo;
  event: NFTEvent;
}) => {
  if (!AID || (!info.location && !info.locationQuery)) return <></>;
  const now = milisecondsToSeconds(Date.now());
  const _eventStart = milisecondsToSeconds(event.start);
  const eventStart = _eventStart < now ? now : _eventStart;
  const eventEnd = milisecondsToSeconds(event.end);
  const address = info.locationQuery || info.location;
  const viewMode = "all";
  const listViewExpand = false;
  const mapStyle = "street";
  const isNear = true;
  const zoom = 16;
  const supportedCurrencies = event.currency?.toLowerCase() || "usd";
  const eseetz = "auto";
  const src = `https://www.stay22.com/embed/gm?aid=${AID}&address=${address}&eventstart=${eventStart}&eventend=${eventEnd}&viewmode=${viewMode}&listviewexpand=${listViewExpand}&mapstyle=${mapStyle}&isnear=${isNear}&zoom=${zoom}&supportedcurrencies=${supportedCurrencies}&eseetz=${eseetz}`;

  console.log("Stay22HotelBooking src:", src);

  return (
    <Flex
      width="100%"
      direction="column"
      justifyContent="center"
      alignItems="center"
      paddingY={8}
    >
      <Flex direction="row" justifyContent="center" alignItems="center" gap={3}>
        <div className=" flex items-center flex-shrink-0 svg-primary">
          <Image src={BathIcon} alt="Bath Icon" width={"36px"} height="100%" />
        </div>

        <Text className="text-2xl dark:text-white">
          {_t("Find a place to stay nearby")}
        </Text>
      </Flex>

      <iframe
        src={src}
        id="stay22-widget"
        className="w-full sm:w-[90%] h-[460px]"
      />
    </Flex>
  );
};

export default Stay22HotelBooking;
